import React from "react";
import { Box, Grid, styled, Typography } from "@mui/material";
import bgImage from "../../resources/images/svg/home/weirdBg2.svg";
import { CenteredSiteBlock } from "../../routes/Home";

import img1 from "../../resources/images/png/home/cultivateSynergies/1.png";
import img2 from "../../resources/images/png/home/cultivateSynergies/2.png";
import img3 from "../../resources/images/png/home/cultivateSynergies/3.png";
import img4 from "../../resources/images/png/home/cultivateSynergies/4.png";
import img5 from "../../resources/images/png/home/cultivateSynergies/5.png";
import img6 from "../../resources/images/png/home/cultivateSynergies/6.png";
import img7 from "../../resources/images/png/home/cultivateSynergies/7.png";
import img8 from "../../resources/images/png/home/cultivateSynergies/8.png";
import { useIsMobile } from "../../hooks/responsive";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundOpacity: 0.22,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  };
});

const synergies = [
  { image: img1, title: "Thérapies brèves" },
  { image: img2, title: "Psychologies et psychothérapies" },
  { image: img3, title: "Approches corporelles" },
  { image: img4, title: "Guidances spirituelles" },
  { image: img5, title: "Techniques énergétiques et vibratoires" },
  { image: img6, title: "Langages sacrés" },
  { image: img7, title: "Soins naturels" },
  { image: img8, title: "Harmonisation des lieux" },
];

const CultivateSynergies = () => {
  const isMobile = useIsMobile();

  return (
    <Container className={"ambitions"}>
      <CenteredSiteBlock
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 500,
              margin: 0,
              textAlign: "center",
              color: "white",
              width: "100%",
            }}
          >
            Cultivez des synergies holistiques
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              margin: 0,
              marginTop: 3,
              fontSize: "18px",
              textAlign: "center",
              color: "white",
              width: "80%",
            }}
          >
            Rejoignez un réseau de professionnels pluridisciplinaires de
            l'accompagnement, du soin et de la conscience, pour faire évoluer
            les pratiques vers plus de cohérence et d'efficacité thérapeutique
            globale.
          </Typography>
        </Box>
        <Grid container spacing={4} mt={4}>
          {synergies.map((synergie, index) => {
            return (
              <Grid
                item
                size={{ xs: 12, md: 4 }}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginLeft: isMobile ? 2 : 0,
                  marginRight: isMobile ? 2 : 0,
                }}
              >
                <Box
                  sx={{
                    // Use the gradient as the background for the outer box
                    background:
                      "linear-gradient(180deg, #0596A1 0%, #3971F6 19.71%, #9A45F4 42.31%, #FC7D06 61.54%, #F7E144 80.77%, #FF4626 100%)",
                    borderRadius: "50%",
                    position: "relative",
                    p: "2px", // This padding creates the visible border width
                    width: isMobile ? "80px" : "120px",
                    minWidth: isMobile ? "80px" : "120px",
                    height: isMobile ? "80px" : "120px",
                    minHeight: isMobile ? "80px" : "120px",
                    // Center the content inside this box
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 0px 20px #9A45F4",
                  }}
                >
                  {/* Inner Box: Contains the image and has the solid background */}
                  <Box
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "50%",
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={synergie.image}
                      alt={"synergie image"}
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Box>
                </Box>
                <Typography
                  sx={{
                    textAlign: "left",
                    fontWeight: 800,
                    fontFamily: "Branding Bold",
                    fontSize: "18px",
                    marginLeft: 2,
                    color: "white",
                  }}
                >
                  {synergie.title}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </CenteredSiteBlock>
    </Container>
  );
};

export default CultivateSynergies;
